import { render, staticRenderFns } from "./pet-name-link.vue?vue&type=template&id=36d9724c&"
import script from "./pet-name-link.vue?vue&type=script&lang=js&"
export * from "./pet-name-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports